import { useEffect } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { useModalContext } from '@bcraft-frontend-lib/core'
import { SLOTS_ROUTE_PATHS } from '@bcraft-frontend-lib/slots'

import { hideChat, showChat } from 'shared/utils/liveChat'

export const useLiveChatVisibility = () => {
  const { pathname } = useLocation()
  const { openedModals, staticOpenedModals } = useModalContext()

  const isSlotFramePage = Boolean(
    matchPath(pathname, { path: SLOTS_ROUTE_PATHS.SLOTS_FRAME_ROOT }),
  )
  const hasOpenModal = openedModals.length > 0 || staticOpenedModals.length > 0

  useEffect(() => {
    if (isSlotFramePage || hasOpenModal) {
      hideChat()
    } else {
      showChat()
    }
  }, [hasOpenModal, isSlotFramePage])
}
